var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDescubra = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "95F9A9DE-9AEB-41AB-AA49-5E8412524C22")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modelos-Originais",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "original",
    transform: "translate(-254.000000, -739.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,18 C267.970563,18 272,21.9781123 272,26.8853625 C272,29.2053404 271.099392,31.3176495 269.624507,32.9001154 L271.057661,34.3146375 C271.448185,34.7001875 271.448185,35.3252875 271.057675,35.7108522 C270.667136,36.0963875 270.033971,36.0963875 269.643447,35.7108375 L268.112147,34.1991559 C266.660203,35.1902144 264.898769,35.770725 263,35.770725 C258.029437,35.770725 254,31.7926127 254,26.8853625 C254,21.9781123 258.029437,18 263,18 Z M263,19.974525 C259.134007,19.974525 256,23.0686123 256,26.8853625 C256,30.7021127 259.134007,33.7962 263,33.7962 C266.865993,33.7962 270,30.7021127 270,26.8853625 C270,23.0686123 266.865993,19.974525 263,19.974525 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDescubra, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/descubra.856fd608.svg";
export { ForwardRef as ReactComponent };